<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      class="adaptationModal salesOrderEdit"
      :title="isCopy ? '销售订单复制' : disabled ? '详情' : sDSalesOrderVO.pkId ? '编辑' : '新建'"
      width="1350px"
      @close="close()">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="sDSalesOrderVO"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <div class="editTitle">销售订单信息</div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="订单编号" prop="salesOrderNO">
            <el-input v-model="sDSalesOrderVO.salesOrderNO" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="订单类型" prop="property">
            <el-select
                v-model="sDSalesOrderVO.property"
                filterable
                placeholder="请选择订单类型"
                :disabled="sDSalesOrderVO.pkId > 0"
                @change="propertyChange">
              <el-option v-for="item in property" :key="item.no" :value="item.no" :label="item.name"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="合同编号" prop="customerContractNo">
            <el-input
                v-model="sDSalesOrderVO.customerContractNo"
                :disabled="disabled
                  || sDSalesOrderVO.property==='ZJA'
                  || sDSalesOrderVO.property==='ZKM'
                  || sDSalesOrderVO.property==='ZRCH'
                  || sDSalesOrderVO.property==='ZKA'"
                placeholder="请选择合同编号"
                readonly>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  :disabled="disabled
                    || sDSalesOrderVO.property==='ZJA'
                    || sDSalesOrderVO.property==='ZKM'
                    || sDSalesOrderVO.property==='ZRCH'
                    || sDSalesOrderVO.property==='ZKA'"
                  @click="$refs.clientContractSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col v-if="qianxu" :span="8">
          <el-form-item label="前续订单">
            <el-input v-model="sDSalesOrderVO.sourceOrder" readonly placeholder="请选择前续订单">
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="$refs.salesOrderSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="sDSalesOrderVO.customerName" readonly placeholder="请选择客户">
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  :disabled="sDSalesOrderVO.pkId > 0"
                  @click="$refs.selectCustomerName.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户行业" prop="customerIndustry">
            <el-select v-model="sDSalesOrderVO.customerIndustry" filterable>
              <el-option v-for="item in customerIndustry" :key="item.no" :value="item.no" :label="item.name"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户BU" prop="buType">
            <el-select v-model="sDSalesOrderVO.buType" filterable>
              <el-option v-for="item in buType" :key="item.no" :value="item.no" :label="item.name"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商务专员" prop="businessSpecialistName">
            <el-input v-model="sDSalesOrderVO.businessSpecialistName" readonly/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="付款方式" prop="paymentTerms">
            <el-select v-model="sDSalesOrderVO.paymentTerms" filterable placeholder="请选择付款方式">
              <el-option v-for="item in payMethods" :key="item.no" :value="item.no" :label="item.name"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="联系人" prop="contact">
            <el-input v-model="sDSalesOrderVO.contact" placeholder="请输入联系人"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系方式" prop="mobile">
            <el-input v-model="sDSalesOrderVO.mobile" type="tel" maxlength="11" placeholder="请输入联系方式"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="详细地址" prop="deliveryPlace">
            <el-input
                v-model="sDSalesOrderVO.deliveryPlace"
                placeholder="请选择详细地址"
                :disabled="!sDSalesOrderVO.customerId">
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  :disabled="!sDSalesOrderVO.customerId"
                  @click="$refs.addressSelect.open(sDSalesOrderVO.customerId)"/>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="销售交期" prop="salesDeliveryDate">
            <el-date-picker
                v-model="sDSalesOrderVO.salesDeliveryDate"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 100%"
                placeholder="选择销售交期"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="计划交期" prop="deliveryDate">
            <el-date-picker
                v-model="sDSalesOrderVO.deliveryDate"
                :disabled="true"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 100%"
                placeholder="选择销售交期"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="最终客户" prop="finalCustomerName">
            <el-input v-model="sDSalesOrderVO.finalCustomerName" readonly placeholder="请选择最终客户">
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  :disabled="sDSalesOrderVO.pkId > 0"
                  @click="$refs.selectFinalCustomer.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
        <!--        <el-col :span="8">-->
        <!--          <el-form-item label="商务申请" prop="businessApplicationNo">-->
        <!--            <el-input-->
        <!--                v-model="sDSalesOrderVO.businessApplicationNo"-->
        <!--                placeholder="请选择商务申请"-->
        <!--                :disabled="!sDSalesOrderVO.customerId">-->
        <!--              <el-button-->
        <!--                  v-if="!sDSalesOrderVO.businessApplicationNo"-->
        <!--                  slot="append"-->
        <!--                  icon="el-icon-search"-->
        <!--                  :disabled="!sDSalesOrderVO.customerId"-->
        <!--                  @click="$refs.selectBusinessApplication.open(sDSalesOrderVO.customerId)"/>-->
        <!--              <el-button v-else slot="append" icon="el-icon-refresh" @click="resetHandle"/>-->
        <!--            </el-input>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户合同编号" prop="customerClientContractNo">
            <el-input v-model="sDSalesOrderVO.customerClientContractNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="ERP订单编号" prop="billNo">
            <el-input v-model="sDSalesOrderVO.billNo" placeholder="请输入ERP订单编号" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="ERP订单编号" prop="billNo">
            <el-input v-model="sDSalesOrderVO.billNo" placeholder="请输入ERP订单编号" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="满赠/返利" prop="giveOrder">
            <el-select v-model="sDSalesOrderVO.giveOrder">
              <el-option label="是" :value="1"/>
              <el-option label="否" :value="0"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col v-if="sDSalesOrderVO.giveOrder" :span="4">
          <el-form-item label="返利(个)满" prop="perReach">
            <el-input v-model="sDSalesOrderVO.perReach"/>
          </el-form-item>
        </el-col>
        <el-col v-if="sDSalesOrderVO.giveOrder" :span="4">
          <el-form-item label="返利(个)赠" prop="perGive">
            <el-input v-model="sDSalesOrderVO.perGive"/>
          </el-form-item>
        </el-col>
        <el-col v-if="sDSalesOrderVO.giveOrder" :span="4">
          <el-form-item label="返利(元)满" prop="amountReach">
            <el-input v-model="sDSalesOrderVO.amountReach"/>
          </el-form-item>
        </el-col>
        <el-col v-if="sDSalesOrderVO.giveOrder" :span="4">
          <el-form-item label="返利(元)赠" prop="amountGive">
            <el-input v-model="sDSalesOrderVO.amountGive"/>
          </el-form-item>
        </el-col>
        <el-col v-if="sDSalesOrderVO.pkId" :span="8">
          <el-form-item label="制单人" prop="creatorName">
            <el-input v-model="sDSalesOrderVO.creatorName" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="sDSalesOrderVO.pkId" :span="8">
          <el-form-item label="制单时间" prop="createTime">
            <el-input v-model="sDSalesOrderVO.createTime" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="sDSalesOrderVO.pkId" :span="8">
          <el-form-item label="状态" prop="statusName">
            <el-input v-model="sDSalesOrderVO.statusName" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="sDSalesOrderVO.property=== 'ZKB'" :span="8">
          <el-form-item label="产品属性" prop="productType">
            <el-select v-model="sDSalesOrderVO.productType">
              <el-option label="样机" :value="'样机'"/>
              <el-option label="备品" :value="'备品'"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="sDSalesOrderVO.property=== 'ZKB'" :span="8">
          <el-form-item label="归还日期" prop="returnDate">
            <el-date-picker
                v-model="sDSalesOrderVO.returnDate"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 100%"
                placeholder="选择交货日期"/>
          </el-form-item>
        </el-col>
        <el-col v-if="['ZKM','ZF1'].toString().includes(sDSalesOrderVO.property)" :span="8">
          <el-form-item label="成本中心" prop="costCenter">
            <el-select v-model="sDSalesOrderVO.costCenter" filterable placeholder="请选择成本中心" @change="selectPayment">
              <el-option v-for="item in costCenterList" :key="item.no" :value="item.no" :label="item.name"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
            v-if="['ZJA','ZDR','ZF1','ZKA','ZKM','ZRCH','ZJB','ZCR','ZKB','ZTRE'].toString().includes(sDSalesOrderVO.property)"
            :span="8">
          <el-form-item label="订购原因" prop="orderReason">
            <el-select v-model="sDSalesOrderVO.orderReason" filterable placeholder="请选择订购原因" @change="selectPayment">
              <el-option v-for="item in orderReasonList" :key="item.no" :value="item.no" :label="item.name"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="sDSalesOrderVO.submitDate" :span="8">
          <el-form-item label="提交时间" prop="submitDate">
            <el-input v-model="sDSalesOrderVO.submitDate" disabled/>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="备注" prop="note">
            <el-input v-model="sDSalesOrderVO.orderNote" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">销售订单物料</div>
      <div style="margin-bottom: 10px">
        <el-button
            type="primary"
            :disabled="!sDSalesOrderVO.customerId || disabled"
            @click="$refs.selectMaterial.open(materialFilter)">
          添加物料
        </el-button>
        <el-button
            type="primary"
            :disabled="!sDSalesOrderVO.customerId || disabled"
            @click="$refs.bomSelect.open()">
          添加BOM
        </el-button>
        <!--        <el-button type="primary" @click="businessApplicationAdd"> 价格申请</el-button>-->
      </div>
      <el-table
          class="orderMaterials"
          :data="sDSalesOrderVO.materialVOS"
          border
          show-summary
          :summary-method="getSummary"
          @select="select"
          @select-all="select">
        <el-table-column type="selection" align="center" width="50" prop="selection"/>
        <el-table-column align="center" type="index" label="#" width="50"/>
        <el-table-column prop="rowType" label="类型" min-width="120"/>
        <el-table-column prop="materialNo" label="物料编号" min-width="120"/>
        <el-table-column prop="specification" label="规格型号" min-width="120"/>
        <el-table-column prop="materialName" label="物料名称" width="250"/>
        <el-table-column align="center" prop="quantity" label="数量" width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.quantity"/>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="unit" label="单位" width="70"/>
        <el-table-column
            v-if="sDSalesOrderVO.giveOrder"
            align="center"
            prop="give"
            label="赠送"
            width="80">
          <template slot-scope="scope">
            <el-select v-model="scope.row.give" clearable>
              <el-option label="是" :value="'X'"/>
              <el-option label="否" :value="''"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
            v-if="sDSalesOrderVO.property === 'ZRCH'"
            align="center"
            prop="SWAP_T"
            label="换入"
            width="80">
          <template slot-scope="scope">
            <el-select v-model="scope.row.SWAP_T" clearable>
              <el-option label="是" :value="'X'"/>
              <el-option label="否" :value="''"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="price" label="单价" width="130">
          <template slot-scope="scope">
            <el-input v-if="scope.row.price === null && disabled" v-model="scope.row.price" placeholder="***"/>
            <el-input v-else v-model="scope.row.price"/>
          </template>
        </el-table-column>
        <el-table-column align="center" label="总价" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.price !== null && limits.priceAuth">{{(scope.row.quantity * scope.row.price).toFixed(2)}}</span>
            <span v-else>***</span>
          </template>
        </el-table-column>
        <el-table-column label="销售交期" align="center" width="160">
          <template slot-scope="scope">
            <el-date-picker
                v-model="scope.row.salesDeliveryDate"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="请选择日期"/>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryDate" label="计划交期" align="center" width="160"/>
        <el-table-column label="备注" width="250">
          <template slot-scope="scope">
            <el-input v-model="scope.row.note" class="note" type="textarea" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="manufacturerModel" label="厂家型号" width="160"/>
        <el-table-column prop="customerMaterialNo" label="客户物料" width="160">
          <template slot-scope="scope">
            <el-input v-model="scope.row.customerMaterialNo"/>
          </template>
        </el-table-column>
        <el-table-column prop="customerMaterialDesc" label="客户物料描述" width="160">
          <template slot-scope="scope">
            <el-input v-model="scope.row.customerMaterialDesc"/>
          </template>
        </el-table-column>
        <el-table-column prop="customerMaterialSpecification" label="客户物料规格" width="160">
          <template slot-scope="scope">
            <el-input v-model="scope.row.customerMaterialSpecification"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="!sDSalesOrderVO.billNo.length" type="danger" @click="deleteHandle(scope)"> 删除</el-button>
            <el-select v-if="sDSalesOrderVO.billNo.length" v-model="scope.row.rejectNo" clearable/>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="close()">取消</el-button>
      <el-button v-if="!disabled" type="primary" :loading="submitLoading" @click="handleSubmit">确定</el-button>
    </span>
    <customer-select ref="selectCustomerName" @select="selectCustomerName"/>
    <customer-select ref="selectFinalCustomer" @select="selectFinalCustomer"/>
    <address-select ref="addressSelect" @select="addressSelect"/>
    <business-application-select ref="selectBusinessApplication" @select="selectBusinessApplication"/>
    <material-select ref="selectMaterial" @select="selectMaterial"/>
    <business-application-edit ref="businessApplicationEdit"/>
    <client-contract-select ref="clientContractSelect" @select="selectClientContract"/>
    <bom-select ref="bomSelect" @select="selectBom"/>
    <sales-order-select ref="salesOrderSelect" @select="selectOrder"/>
    <!-- <employee-select ref="employeeSelect" @select="onSelectEmployee"/> -->
  </el-dialog>
</template>

<script>
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import AddressSelect from "@/views/information/Customer/CustomerAddressSelect";
  import BusinessApplicationSelect from "../BusinessApplication/BusinessApplicationSelect";
  import BusinessApplicationEdit from "../BusinessApplication/BusinessApplicationEdit";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import ClientContractSelect from "@/views/SalesManage/SalesClientContract/ClientContractSelect";
  import BomSelect from "@/views/information/BomManage/BomSelect";
  import SalesOrderSelect from "@/views/SalesManage/SalesOrder/SalesOrderSelect";
  import loginUtil from "@/util/loginUtil";

  export default {
    components: {
      SalesOrderSelect,
      BomSelect,
      ClientContractSelect,
      CustomerSelect,
      BusinessApplicationSelect,
      MaterialSelect,
      AddressSelect,
      BusinessApplicationEdit,
    },
    props: {
      options: {
        type: Array,
        default: () => {
          return [];
        },
      },
    },

    data() {
      return {
        limits: {
          priceAuth:this.$auth(96),
        },
        billId: "0",
        billType: "1",
        downLoadAuth: this.$auth(369),
        authIndex: 369,
        selection: [],
        disabled: false,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        isCopy: 0,
        isReturn: false,
        sDSalesOrderVO: {
          pkId: 0,
          creatorId: loginUtil.getUserId(),
          property: "",
          costCenter: "",
          orderReason: "",
          salesOrderNO: "",
          countersignName: "",
          billNo: "",
          clientContractId: "",
          customerContractNo: "",
          projectName: "",
          deliveryDate: "",
          customerId: "",
          customerNo: "",
          customerName: "",
          contact: "",
          mobile: "",
          districtId: "",
          districtIdCopy: [],
          deliveryPlace: "",
          salesDeliveryDate: "",
          orderNote: "",
          salesPriceBaId: "",
          businessApplicationNo: "",
          materialVOS: [],
          attachments: [],
          paymentTerms: "",
          paymentName: "",
          finalCustomerName: "",
          finalCustomerNo: "",
          finalCustomerId: "",
          productType: "",
          customerClientContractNo: "",
          businessSpecialist: "",
          businessSpecialistName: "",
          customerIndustry: "",
          customerIndustryName: "",
          buType: "",
          buTypeName: "",
          perReach: "",
          perGive: "",
          amountReach: "",
          amountGive: "",
          giveOrder: 0,
          sourceOrder: "",
          returnDate: "",
          note: "",
        },
        payMethods: [],
        costCenterList: [],
        orderReasonList: [],
        property: [],
        customerIndustry: [],
        buType: [],
        bom: {},
        qianxu: 0,
        qianxuList: [
          "ZJA",
          "ZJE",
          "ZTRE",
          "ZT2",
          "ZKA",
          "ZKE",
          "ZKM",
        ],
        materialFilter: {
          status: 10,//启用
          priceStatus: 30,//已通过
        },
        ruleValidate: {
          // customerContractNo: { required: true, message: "请输入客户合同号" },
          salesDeliveryDate: {required: true, message: "请选择交货日期"},
          customerName: {required: true, message: "请选择客户"},
          returnDate: {required: true, message: "请选择归还日期"},
          contact: {required: true, message: "请输入联系人", trigger: "blur"},
          mobile: {required: true, message: "请输入联系方式", trigger: "blur"},
          deliveryPlace: {required: true, message: "请输入详细地址", trigger: "blur"},
          districtIdCopy: {required: true, message: "请选择所属区域"},
          paymentName: {required: true, message: "请选择付款方式", trigger: "change"},
          property: {required: true, message: "请选择订单类型"},
          orderReason: {required: true, message: "请选择订购原因"},
          costCenter: {required: true, message: "请选择成本中心"},
          customerIndustry: {required: true, message: "请选择客户行业"},
          buType: {required: true, message: "请选择客户BU"},
        },
        businessApplicationPrice: 0, // 商务申请审批价格
      };
    },

    methods: {
      getSummary(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "合计";
          } else if (column.property === "quantity") {
            const totalQuantity = data.reduce((prev, curr) => {
              const value = Number(curr.quantity) || 0;
              return prev + value;
            }, 0);
            sums[index] = totalQuantity;
          } else if (column.label === "总价") {
            const totalPrice = data.reduce((prev, curr) => {
              const value = Number(curr.quantity) * Number(curr.price) || 0;
              return prev + value;
            }, 0);
            sums[index] = totalPrice.toFixed(2);
          } else {
            sums[index] = "";
          }
        });
        return sums;
      },
      
      open(row, isCopy, disabled) {
        this.dialogVisible = true;
        this.isCopy = isCopy;
        this.disabled = disabled;
        if (row) {
          this.billId = row.pkId.toString();
        }
        this.$nextTick(() => {
          this.getPaymentTypes();
          this.getSalesOrderCategory();
          this.getBu();
          this.getcostCenter();
          this.getorderReason();
          this.getCustomerIndustry();
          if (row) {
            this.getData(row.pkId);
            if (this.qianxuList.toString().includes(this.sDSalesOrderVO.property)) {
              this.qianxu = 1;
            }
          }
        });
      },

      close() {
        this.dialogVisible = false;
        this.billId = "0";
        this.billType = "1";
        this.sDSalesOrderVO = {};
        this.$reset("form");
      },
      deleteHandle(scope) {
        if (scope.row.randomIndex && scope.row.rowType === "虚拟抬头") {
          let newArr = [];
          this.sDSalesOrderVO.materialVOS.forEach((item) => {
            if (item.randomIndex !== scope.row.randomIndex) {
              newArr.push(item);
            }
          });
          this.sDSalesOrderVO.materialVOS = newArr;
        } else {
          this.sDSalesOrderVO.materialVOS.splice(scope.$index, 1);
        }

      },
      select(selection) {
        this.selection = selection;
      },

      // 选择客户
      selectCustomerName(row) {
        console.log(row);
        this.sDSalesOrderVO.customerId = row.customerID;
        this.sDSalesOrderVO.customerNo = row.outerNo;
        this.sDSalesOrderVO.customerName = row.customerName;
        this.sDSalesOrderVO.paymentTerms = row.zterm;
        this.sDSalesOrderVO.buType = row.industryToWhich;
        this.sDSalesOrderVO.customerIndustry = row.industry;
        this.sDSalesOrderVO.businessSpecialistName = row.businessSpecialistName;
        this.sDSalesOrderVO.finalCustomerId = row.customerID;
        this.sDSalesOrderVO.finalCustomerNo = row.outerNo;
        this.sDSalesOrderVO.finalCustomerName = row.customerName;
        if (!this.sDSalesOrderVO.pkId) {
          this.getAddress(this.sDSalesOrderVO.customerNo);
        }
      },

      selectFinalCustomer(row) {
        this.sDSalesOrderVO.finalCustomerId = row.customerID;
        this.sDSalesOrderVO.finalCustomerNo = row.outerNo;
        this.sDSalesOrderVO.finalCustomerName = row.customerName;
      },
      //订单类型
      propertyChange() {
        console.log(this.sDSalesOrderVO.property);
        this.sDSalesOrderVO.costCenter="";
        this.sDSalesOrderVO.orderReason="";
        if (this.qianxuList.toString().includes(this.sDSalesOrderVO.property)) {
          this.qianxu = 1;
        } else {
          this.qianxu = 0;
        }
      },
      // 付款方式
      getPaymentTypes() {
        this.payMethods = [
          { no: "P090", name: "月结30天付款" },
          { no: "P091", name: "月结60天付款" },
          { no: "P092", name: "月结90天付款" },
          { no: "P093", name: "月结120天付款" },
          { no: "P094", name: "月结150天付款" },
          { no: "P095", name: "月结180天付款" },
          { no: "P096", name: "预付100%发货" },
          { no: "P097", name: "预付30%，尾款货到7天付清" },
          { no: "P098", name: "货到7天" },
          { no: "P099", name: "月结100天付款" },
        ];
        // this.$http.get("basic", "sapSalesOrders/getPaymentType").then((res) => {
        //   if (res.success) {
        //     this.payMethods = res.data;
        //   }
        // });
      },

      getSalesOrderCategory() {
        this.$http.get("basic", "sapSalesOrders/getSalesOrderCategory").then((res) => {
          if (res.success) {
            this.property = res.data;
          }
        });
      },

      getcostCenter() {
        this.$http.get("basic", "sapSalesOrders/getcostCenter").then((res) => {
          if (res.success) {
            this.costCenterList = res.data;
          }
        });
      },

      getorderReason() {
        this.$http.get("basic", "sapSalesOrders/getorderReason").then((res) => {
          if (res.success) {
            this.orderReasonList = res.data;
          }
        });
      },

      getBu() {
        this.$http.get("basic", "sapSalesOrders/getBu").then((res) => {
          if (res.success) {
            this.buType = res.data;
          }
        });
      },

      getCustomerIndustry() {
        this.$http.get("basic", "sapSalesOrders/getCustomerIndustry").then((res) => {
          if (res.success) {
            this.customerIndustry = res.data;
          }
        });
      },

      // 附件下载
      downLoad(row) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.filePath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },

      getAddress(customerNo) {
        this.$http.get("basic", `customerDeliveryAddress/selectDefaultAddress/${customerNo}`).then((res) => {
          if (res.success) {
            if (res.data != null) {
              this.sDSalesOrderVO.contact = res.data.contact;
              this.sDSalesOrderVO.mobile = res.data.telephone;
              this.sDSalesOrderVO.deliveryPlace = res.data.addressName;
            } else {
              this.sDSalesOrderVO.contact = "";
              this.sDSalesOrderVO.mobile = "";
              this.sDSalesOrderVO.deliveryPlace = "";
            }
          }
        });
      },

      // 选择详细地址
      addressSelect(row) {
        console.log(row);
        this.sDSalesOrderVO.deliveryPlace = row.addressName;
        this.sDSalesOrderVO.contact = row.contact;
        this.sDSalesOrderVO.mobile = row.telephone;
      },

      // 选择商务申请
      selectBusinessApplication(row) {
        this.sDSalesOrderVO.salesPriceBaId = row.businessApplicationID;
        this.sDSalesOrderVO.businessApplicationNo = row.businessApplicationNO;
        this.businessApplicationPrice = row.approve3Price;
        this.$http
          .post("basic", "sd/so/setPrice", this.sDSalesOrderVO)
          .then((resp) => {
            if (resp.success) {
              resp.data.materialVOS.forEach((item, index) => {
                this.sDSalesOrderVO.materialVOS[index].standardPrice = item.standardPrice;
                this.sDSalesOrderVO.materialVOS[index].price = item.price;
              });
            }
          })
          .catch(() => {
          });
      },

      resetHandle() {
        this.sDSalesOrderVO.salesPriceBaId = "";
        this.sDSalesOrderVO.businessApplicationNo = "";
        this.businessApplicationPrice = 0;
        if (this.sDSalesOrderVO.materialVOS.length) {
          this.sDSalesOrderVO.materialVOS.forEach((item) => {
            item.price = 0;
          });
        }
      },

      // 添加物料
      selectMaterial(row) {
        console.log(row);
        let obj = {
          materialId: row.id,
          materialNo: row.no,
          materialName: row.name,
          specification: row.zmyxh,
          quantity: 1,
          unit: row.unit,
          manufacturerModel: row.manufacturerModel,
          salesDeliveryDate: this.sDSalesOrderVO.salesDeliveryDate,
          rowType: "销售物料",
        };
        // if (this.sDSalesOrderVO.businessApplicationNo) {
        //   obj.price = this.businessApplicationPrice;
        // }
        this.sDSalesOrderVO.materialVOS.push(obj);
        this.$http
          .post("basic", "sd/so/setPrice", this.sDSalesOrderVO)
          .then((resp) => {
            if (resp.success) {
              this.sDSalesOrderVO.materialVOS = resp.data.materialVOS;
            }
          })
          .catch(() => {
            this.sDSalesOrderVO.materialVOS.splice(this.sDSalesOrderVO.materialVOS.length - 1, 1);
          });
      },

      //校验物料
      checkMaterialFirst(obj) {
        this.$http
          .post("basic", "sd/so/ma/checkMaterial", obj)
          .then((resp) => {
            if (resp.success && resp.data) {
              // this.$message.warning("当前客户首次添加该产品【" + obj.materialNO + "】,请检查是否正确选择产品.");
              // this.$confirm("当前客户首次添加该产品【" + obj.materialNO + "】,请检查是否正确选择产品.", "提示", {
              //   type: "warning",
              //   showCancelButton: false,
              // });
              this.$confirm(resp.data, "提示", {
                type: "warning",
                showCancelButton: false,
              });
            }
          })
          .catch(() => {
          });
      },

      // 上传文件
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
          };
          this.sDSalesOrderVO.attachments.push(params);
        }
      },

      // 获取订单详情
      getData(pkId) {
        this.contentLoading = true;
        this.$http
          .get("basic", `sapSalesOrders/${pkId}`)
          .then((res) => {
            if (res.success) {
              this.sDSalesOrderVO = res.data;
              this.sDSalesOrderVO.districtIdCopy = res.data.districtId.split(",").map((item) => parseInt(item));
              if (this.isCopy) {
                this.sDSalesOrderVO.pkId = "";
                this.sDSalesOrderVO.submitDate = "";
                this.sDSalesOrderVO.erpSalesOrderNo = "";
              }
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      businessApplicationAdd() {
        if (this.selection.length === 0) {
          this.$message.error("至少选择一列");
          return;
        }
        let params = {
          materialList: this.selection,
          sDSalesOrderVO: JSON.stringify(this.sDSalesOrderVO),
        };
        this.dialogVisible = false;
        this.$refs.businessApplicationEdit.open(params, 0, 1);
      },

      // 提交
      handleSubmit() {
        console.log(this.sDSalesOrderVO);
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.sDSalesOrderVO.materialVOS.length) {
              this.$confirm("请添加订单物料!", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            // this.sDSalesOrderVO.districtId = this.sDSalesOrderVO.districtIdCopy.join(",");
            this.submitLoading = true;
            // 编辑
            if (this.sDSalesOrderVO.pkId) {
              if (this.sDSalesOrderVO.billNo.length) {
                this.$http
                  .post("basic", "sapSalesOrders/uptSapSalesOrder", this.sDSalesOrderVO)
                  .then((res) => {
                    if (res.success) {
                      this.$emit("save-success");
                      this.$message.success("编辑成功");
                      this.dialogVisible = false;
                    }
                    this.submitLoading = false;
                  })
                  .catch(() => {
                    this.submitLoading = false;
                  });
              } else {
                console.log(this.sDSalesOrderVO);
                this.$http
                  .post("basic", "sapSalesOrders/update", this.sDSalesOrderVO)
                  .then((res) => {
                    if (res.success) {
                      this.$emit("save-success");
                      this.$message.success("编辑成功");
                      this.dialogVisible = false;
                    }
                    this.submitLoading = false;
                  })
                  .catch(() => {
                    this.submitLoading = false;
                  });
              }
            } else {
              // 新建
              this.$http
                .post("basic", "sapSalesOrders/save", this.sDSalesOrderVO)
                .then((res) => {
                  if (res.success) {
                    // 关闭标签
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                    this.dialogVisible = false;
                  }
                  this.submitLoading = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },

      selectPayment() {
        let item = this.payMethods.filter(item => item.no === this.sDSalesOrderVO.paymentType);
        this.sDSalesOrderVO.paymentName = item.name;
      },

      selectClientContract(row) {
        console.log(row);
        this.$http.get("basic", `clientContracts/getSalesOrderByClientContract/${row.pkId}`)
          .then((res) => {
            if (res.success) {
              let property = this.sDSalesOrderVO.property;
              this.sDSalesOrderVO = res.data;
              this.sDSalesOrderVO.property = property;
              this.sDSalesOrderVO.billNo = "";
              console.log(this.sDSalesOrderVO);
              this.sDSalesOrderVO.customerClientContractNo = res.data.customerClientContractNo;
              if (row.clientContractType === 50) {
                this.sDSalesOrderVO.productType = "样机";
              } else if (row.clientContractType === 60) {
                this.sDSalesOrderVO.productType = "备品";
              }
            }
          });

      },

      selectBom(row) {
        this.$http.get("basic", `sapBoms/${row.materialNo}`)
          .then((res) => {
            if (res.success) {
              this.bom = res.data;
              console.log(res.data);
              //生成随机6位数
              let random = Math.floor(Math.random() * 1000000);
              let obj = {
                materialId: this.bom.materialId,
                materialNo: this.bom.materialNo,
                materialName: this.bom.materialName,
                specification: this.bom.specification,
                quantity: row.quantity,
                unit: this.bom.unit,
                randomIndex: random,
                manufacturerModel: this.bom.manufacturerModel,
                salesDeliveryDate: this.sDSalesOrderVO.salesDeliveryDate,
                rowType: "虚拟抬头",
              };

              this.sDSalesOrderVO.materialVOS.push(obj);

              this.bom.bomDetails.forEach((item) => {
                let obj = {
                  materialId: item.partsId,
                  materialNo: item.materialNo,
                  materialName: item.materialName,
                  specification: item.specification,
                  quantity: item.quantity * row.quantity,
                  unit: item.unit,
                  manufacturerModel: item.manufacturerModel,
                  salesDeliveryDate: this.sDSalesOrderVO.salesDeliveryDate,
                  rowType: "销售物料",
                  randomIndex: random,
                };
                this.sDSalesOrderVO.materialVOS.push(obj);
              });

              this.$http
                .post("basic", "sd/so/setPrice", this.sDSalesOrderVO)
                .then((resp) => {
                  if (resp.success) {
                    this.sDSalesOrderVO.materialVOS = resp.data.materialVOS;
                  }
                })
                .catch(() => {
                  this.sDSalesOrderVO.materialVOS.splice(this.sDSalesOrderVO.materialVOS.length - 1, 1);
                });
            }
          }).catch((res) => {
            this.$message.error(res);
          });
        console.log(this.sDSalesOrderVO.materialVOS);
      },

      selectOrder(row) {
        this.sDSalesOrderVO.sourceOrder = row.billNo;
        this.$http
          .get("basic", `sapSalesOrders/getSourceOrder/${row.pkId}`)
          .then((res) => {
            if (res.success) {
              let property = this.sDSalesOrderVO.property;
              this.sDSalesOrderVO = res.data;
              this.sDSalesOrderVO.property = property;
              this.sDSalesOrderVO.sourceOrder = res.data.billNo;
              this.sDSalesOrderVO.pkId = "";
              this.sDSalesOrderVO.submitDate = "";
              this.sDSalesOrderVO.erpSalesOrderNo = "";
              this.sDSalesOrderVO.billNo = "";
              this.sDSalesOrderVO.salesDeliveryDate = "";
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      onSelectEmployee(row) {
        this.sDSalesOrderVO.countersignNumber = row.oaNumber;
        this.clientContract.countersignName = row.employeeName;
      },
    },
  };
</script>

<style lang="scss">
.salesOrderEdit {
  .el-table-column--selection .cell {
    padding-right: 10px;
  }

  .orderMaterials .el-input__inner {
    text-align: center;
  }

  .orderMaterials .note .el-input__inner {
    text-align: left;
  }
}
</style>
